export const getAjaxError = response => {
  const fallbackMessage = "An error occurred. Please try again.";

  if (!response || !response.responseText || response.responseText === "undefined") {
    return fallbackMessage;
  }

  try {
    return $.parseJSON(response.responseText).error.quantity;
  } catch (e) {
    return fallbackMessage;
  }
};
export const csrftoken = $.cookie("csrftoken");

export default $(document).ready(e => {
  function csrfSafeMethod(method) {
    return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
  }

  $.ajaxSetup({
    beforeSend: function(xhr, settings) {
      if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
        xhr.setRequestHeader("X-CSRFToken", csrftoken);
      }
    }
  });

  // Open tab from the link

  let hash = window.location.hash;
  $('.nav-tabs a[href="' + hash + '"]').tab("show");

});
